import { isFulfilled } from '@reduxjs/toolkit'
import { FC, useEffect, useMemo } from 'react'
import { useToasts } from 'react-toast-notifications'

import CustomButton from '../UI/Buttons/CustomButton'
import TrashIcon from '../UI/Icons/Trash'
import { TOAST_MESSAGE } from '../UI/ToastNotification/ToastNotification'
import { APPROVAL_LIST_TYPE } from '../../store/application/types'

import './SelectedPosts.scss'

export enum SELECTED_POPUP_PAGE {
  CALENDAR = 'calendar',
  APPROVAL = 'approval',
  CONTENT = 'content',
  TEAM = 'team'
}

interface SelectedPostPopupProps {
  selectedPostIds: number[]
  setSelectedPosts: (posts: any[]) => any
  updateSchedules?: any
  deleteSchedules?: (ids: number[]) => any
  showDeleteModal?: () => any
  toggleSendToApprovalPosts?: () => any
  isRemovingSchedule?: boolean
  toggleUpdateSchedules?: () => any
  toggleDuplicatePost?: () => any
  isUpdatingPostSchedule?: boolean
  approveSelectedPosts?: () => any
  qtyToApprove?: number
  qtyToSchedule?: number
  page: SELECTED_POPUP_PAGE
  approvalListType?:string
}

// TODO clear popup
const SelectedPostPopup: FC<SelectedPostPopupProps> = ({
  selectedPostIds,
  setSelectedPosts,
  updateSchedules,
  deleteSchedules,
  showDeleteModal,
  isRemovingSchedule,
  toggleUpdateSchedules,
  toggleDuplicatePost,
  isUpdatingPostSchedule,
  toggleSendToApprovalPosts,
  approveSelectedPosts,
  qtyToApprove,
  qtyToSchedule,
  page,
  approvalListType,
  ...props
}) => {
  const { addToast } = useToasts()
  const isOpen = !!selectedPostIds.length
  const clearSelected = () => {
    setSelectedPosts([])
  }

  useEffect(() => () => clearSelected(), [])

  const removeSchedules = async () => {
    if (page === SELECTED_POPUP_PAGE.CONTENT || page === SELECTED_POPUP_PAGE.CALENDAR) {
      showDeleteModal && showDeleteModal()
    } else if (page === SELECTED_POPUP_PAGE.TEAM) {
      showDeleteModal && showDeleteModal()
    }
  }

  return (
    <div className={`selected-posts ${isOpen && 'visible'}`}>
      {(page === SELECTED_POPUP_PAGE.CALENDAR || page === SELECTED_POPUP_PAGE.CONTENT) && (
        <>
          <div className='selected-posts__quantity'>
            <div className='selected-posts__quantity__remove-all' onClick={clearSelected}></div>
            {selectedPostIds.length} Selected
          </div>
          <div className='selected-posts__actions'>
            <CustomButton
              button='primary'
              disabled={!qtyToApprove}
              type='submit'
              onClick={toggleSendToApprovalPosts}
            >
              To Approval
            </CustomButton>
            <CustomButton
              // inProgress={isUpdatingPostSchedule}
              onClick={toggleUpdateSchedules}
              disabled={!qtyToSchedule}
              button='primary'
              type='submit'
              className='change-schedule'
            >
              Change Schedule
            </CustomButton>
            <CustomButton 
              button='primary' 
              disabled={selectedPostIds.length !== 1}
              onClick={toggleDuplicatePost}>
              Clone Posts 
            </CustomButton>
            <CustomButton
              inProgress={isRemovingSchedule}
              onClick={removeSchedules}
              button='delete'
              type='submit'
            >
              {!isRemovingSchedule && <TrashIcon />}
            </CustomButton>
          </div>
        </>
      )}
      {page === SELECTED_POPUP_PAGE.APPROVAL && (
        <>
          <div className='selected-posts__quantity'>
            <div className='selected-posts__quantity__remove-all' onClick={clearSelected}></div>
            {selectedPostIds.length} Selected
          </div>
          <div className='selected-posts__actions'>
            <CustomButton onClick={approveSelectedPosts} button='primary' type='submit'>
            {approvalListType === APPROVAL_LIST_TYPE.APPROVED?'Unapprove':'Approve'}
            </CustomButton>
          </div>
        </>
      )}
      {page === SELECTED_POPUP_PAGE.TEAM && (
        <>
          <div className='selected-posts__quantity'>
            <div className='selected-posts__quantity__remove-all' onClick={clearSelected}></div>
            {selectedPostIds.length} Selected
          </div>
          <div className='selected-posts__actions'>
            <CustomButton
              inProgress={isRemovingSchedule}
              onClick={removeSchedules}
              button='delete'
              type='submit'
            >
              {!isRemovingSchedule && <TrashIcon />}
            </CustomButton>
          </div>
        </>
      )}
    </div>
  )
}

export default SelectedPostPopup
